// eslint-no-undef
import React from 'react';
import '../App.css';
import InviteModal from './InviteModal';
import MapContainer from './MapContainer';

export default class RightColumn extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  showInviteModal(event) {
    event.preventDefault();
    this.props.app.setState({modal: <InviteModal app={this.props.app} user={this.props.app.state.user} />});
  }

  render() {
    return (
      <div className='rightdiv'>
        <div className='rightInnerFixedWrapper'>
          <div className='rightInnerFixed'>
            <MapContainer area={this.props.area} lat={this.props.lat} lon={this.props.lon} />
            <div className='rightFloater'><span className='fakeLink' onClick={(e) => this.showInviteModal(e)}>Convite</span></div>
            <div className='rightInner'>
              {this.props.area.name}
              <br />
              <span className='normalSmallText'><span className='fakeLink' onClick={(e) => this.props.app.showNeighbors(e)}><font className='commentActionFontBlue'>{this.props.area.user_count} vizinhos</font></span></span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

